import './index.html';
import '../css/style.css';
import '../css/owfont-regular.css';

import './js/localStorage';
import './js/image-slider';
import './js/currentTime';
import './js/currentDate';
import './js/greeting';
import './js/weather';
import './js/quotes';
import './js/audioplayer';
import './js/settings';
import './js/clockStyleSettings';
import './js/imagesApi';
import './js/translation';
